import { useEffect, useRef } from 'react';
import { useToasts } from '../state/ToastContext';

const useMockDataToast = (isFallback: boolean, message: string, detail?: string) => {
  const { pushToast } = useToasts();
  const hasShownRef = useRef(false);

  useEffect(() => {
    if (isFallback && !hasShownRef.current) {
      pushToast({ tone: 'warning', message, detail });
      hasShownRef.current = true;
    }
  }, [detail, isFallback, message, pushToast]);
};

export default useMockDataToast;
